import { useEffect, useState } from "react";
import { getAllBranch } from "api/BranchDetailsApi";

import Mumbai from "../../images/Thanshiq/diamond mainpage/CityLocation/Mumbai.png";
import bangalore from "../../images/Thanshiq/diamond mainpage/CityLocation/Bangalore.png";
import chennai from "../../images/Thanshiq/diamond mainpage/CityLocation/chennai.png";
import Delhi from "../../images/Thanshiq/diamond mainpage/CityLocation/Delhi.png";
import Hydrabad from "../../images/Thanshiq/diamond mainpage/CityLocation/Hyderabad.png";
import jaipur from "../../images/Thanshiq/diamond mainpage/CityLocation/jaipur.png";
import kolkata from "../../images/Thanshiq/diamond mainpage/CityLocation/Kolkata.png";
import patna from "../../images/Thanshiq/diamond mainpage/CityLocation/Patna.png";
import pune from "../../images/Thanshiq/diamond mainpage/CityLocation/Pune.png";

import firstE1 from "../../images/imgT4.jpg";
import secondE from "../../images/Thanshiq/diamond mainpage/CityLocation/sesonsOfStyle.4b7bd3f87c0efd2192cb.jpg";
import thirdE from "../../images/212.jpg";
import ar from "../../images/Thanshiq/diamond mainpage/CityLocation/main/10050.png";

import location from "../../images/Thanshiq/diamond mainpage/CityLocation/main/10024.png";
import search from "../../images/Thanshiq/diamond mainpage/CityLocation/main/10025.png";

function CityLocation({ configImages }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredStores, setFilteredStores] = useState([]);
  const [data, setData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [activeStoreIndex, setActiveStoreIndex] = useState(null);
  const handleGetDirectionsClick = (index) => {
    setActiveStoreIndex(index);
  };


  useEffect(() => {
    getAllBranch({}).then((data) => {
      setData(data.response.content);
    });
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsChecked(false);
  };

  const handleCheckButtonClick = () => {
    if (!searchTerm.trim()) {
      setFilteredStores([]);
      setIsChecked(true);
      return;
    }
    const results = data.filter((store) => {
      return (
        store.branchAddress?.city?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
        store.branchAddress?.pincodeNumber?.includes(searchTerm) ||
        store.storeName?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
        store.branchAddress?.address1?.toLowerCase()?.includes(searchTerm.toLowerCase())
      );
    });
    setFilteredStores(results);
    setIsChecked(true);
  };

  const stores = [
    { storeCount: 27, city: "Mumbai", imageSrc: Mumbai },
    { storeCount: 18, city: "Delhi", imageSrc: Delhi },
    { storeCount: 24, city: "Bangalore", imageSrc: bangalore },
    { storeCount: 16, city: "Hyderabad", imageSrc: Hydrabad },
    { storeCount: 21, city: "Chennai", imageSrc: chennai },
    { storeCount: 11, city: "Pune", imageSrc: pune },
    { storeCount: 16, city: "Kolkata", imageSrc: kolkata },
    { storeCount: 7, city: "Patna", imageSrc: patna },
    { storeCount: 4, city: "Jaipur", imageSrc: jaipur },
  ];

  return (
    <div style={{ background: "white", padding: "30px" }}>
      {/* Heading */}
      <h1 style={{ textAlign: "center", color: "#8d2323" }}>
        Welcome to MGDM
      </h1>

      {/* Search */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "500px",
          margin: "auto",
          border: "1px solid black",
          borderRadius: "10px",
          padding: "5px",
          backgroundColor: "white",
        }}
      >
        <span style={{ padding: "5px" }}>
          <img src={location} alt="Location Icon" style={{ height: "30px" }} />
        </span>
        <input
          type="text"
          className="form-control p-2 text-dark"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder="Search by city / pincode / store"
          style={{ flex: 1, border: "none", outline: "none", paddingLeft: "5px" }}
        />
        <span style={{ padding: "5px", cursor: "pointer" }}>
          <img
            src={search}
            onClick={handleCheckButtonClick}
            alt="Search Icon"
            style={{ height: "30px" }}
          />
        </span>
      </div>

      {/* Results */}
      <section className="bg-light py-5 mt-2 shadow-sm">
        <div className="container">
          <div className="row justify-content-center">
            <span className="text-center mb-3">
              {isChecked ? (
                filteredStores.length > 0 ? (
                  <div>Found {filteredStores.length} stores near you</div>
                ) : searchTerm.trim() ? (
                  <div>No stores found for "{searchTerm}"</div>
                ) : null
              ) : (
                <div>Found {data.length} stores near you</div>
              )}
            </span>

            {/* Store Cards */}
            {isChecked &&
              filteredStores.map((store, index) => (
                <div
                  className="col-lg-4 mb-3 d-flex align-items-stretch"
                  key={store.id}
                >
                  <div className="card shadow-sm">
                    {/* <img
                      src={
                        configImages &&
                        configImages.STORIMAGES[index % configImages.STORIMAGES.length].value
                      }
                      className="card-img-top"
                      alt="Store"
                    /> */}
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title text-uppercase">
                        {store.storeName}{" "}
                        <small className="text-muted">{store.branchName}</small>
                      </h5>
                      <p className="card-text mb-1">
                        <i className="bi bi-shop me-2 text-danger"></i>
                        {store.branchAddress?.address1 || ""}{" "}
                        {store.branchAddress?.address2 || ""}
                      </p>
                      <p className="card-text mb-1">
                        <i className="bi bi-envelope me-2 text-danger"></i>
                        {store.email || "No Email"}
                      </p>
                      <p className="card-text mb-1">
                        <i className="bi bi-geo-alt me-2 text-danger"></i>
                        {store.branchAddress?.districtName || ""} -{" "}
                        {store.branchAddress?.pincodeNumber || "No Pincode"}
                      </p>
                      <p className="card-text mb-1">
                        <i className="bi bi-globe me-2 text-danger"></i>
                        {store.branchAddress?.stateName || ""},{" "}
                        {store.branchAddress?.countryName || ""}
                      </p>
                      <p className="card-text mb-1">
                        <i className="bi bi-telephone me-2 text-danger"></i>
                        {store.countryCode} {store.mobile || ""}
                      </p>
                      <p className="card-text mb-1">
                        <i className="bi bi-telephone me-2 text-danger"></i>
                        {store.landline || "No Landline"}
                      </p>
                      <button className="btn btn-outline-danger mt-auto"
                        onClick={() => handleGetDirectionsClick(index)}>
                        Get Directions
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            <div className="container">
              <div className="row py-4">
                {isChecked && filteredStores.map((store, index) => (
                  <div className="col-md-6" id={`getDirection${index}`} key={store.id}>
                    {activeStoreIndex === index && (
                      <div className="box bg-light position-relative mw-100">
                        <div className="box-inner p-0">
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15628.037973207232!2d78.1098746!3d11.6937394!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babfa788db1bcfb%3A0x83c01f3855c7e06b!2sRasi%20Infotech!5e0!3m2!1sen!2sin!4v1679916954190!5m2!1sen!2sin"
                            width="100%"
                            height="450"
                            allowfullscreen=""
                            data-lazy="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                            title="branch one"
                          ></iframe>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Images */}
      <div style={{ textAlign: "center", color: "#8d2323", marginTop: "80px" }}>
        <h1>Explore our latest collections online even before you walk in!</h1>
      </div>
      {/* <div className="p-2">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
        >
          <img src={firstE1} alt="First Event" style={{ height: "500px", borderRadius: "20px", maxWidth: "100%" }} />
          <img src={secondE} alt="Second Event" style={{ height: "500px", borderRadius: "20px", maxWidth: "100%" }} />
          <img src={thirdE} alt="Third Event" style={{ height: "500px", borderRadius: "20px", maxWidth: "100%" }} />
        </div>
      </div> */}

      <div
        style={{
          backgroundColor: "#fbfbf3",
          textAlign: "center",
          padding: "20px",
          borderRadius: "10px",
          marginTop: "40px",
        }}
      >
        <h3 style={{ color: "#8d2323" }}>Suggested Articles</h3>
        <small>Read more help and support articles, blogs here</small>
        <div style={{ marginTop: "10px" }}>
          <a href="#" className="d-flex align-items-center justify-content-center text-dark mb-2">
            <img src={ar} alt="Article Icon" style={{ height: "20px", marginRight: "8px" }} />
            Stories from MGDM ERP Exchange: A Journey of Trust, Loyalty, and Cherished Memories
          </a>
          <a href="#" className="d-flex align-items-center justify-content-center text-dark mb-2">
            <img src={ar} alt="Article Icon" style={{ height: "20px", marginRight: "8px" }} />
            The Heart of Rivaah: What MGDM ERP’s wedding brand stands for
          </a>
          <a href="#" className="d-flex align-items-center justify-content-center text-dark">
            <img src={ar} alt="Article Icon" style={{ height: "20px", marginRight: "8px" }} />
            Mixing and Matching Earring Styles for Every Occasion
          </a>
        </div>
      </div>
    </div>
  );
}

export default CityLocation;
